import { render, staticRenderFns } from "./SchemaPaginatedTable.vue?vue&type=template&id=ef5a5b22&scoped=true"
import script from "./SchemaPaginatedTable.vue?vue&type=script&lang=js"
export * from "./SchemaPaginatedTable.vue?vue&type=script&lang=js"
import style0 from "./SchemaPaginatedTable.vue?vue&type=style&index=0&id=ef5a5b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5a5b22",
  null
  
)

export default component.exports